import { render, staticRenderFns } from "./mydakalistitem.vue?vue&type=template&id=6ae578ed&class=component&"
import script from "./mydakalistitem.vue?vue&type=script&lang=js&"
export * from "./mydakalistitem.vue?vue&type=script&lang=js&"
import style0 from "./mydakalistitem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae578ed')) {
      api.createRecord('6ae578ed', component.options)
    } else {
      api.reload('6ae578ed', component.options)
    }
    module.hot.accept("./mydakalistitem.vue?vue&type=template&id=6ae578ed&class=component&", function () {
      api.rerender('6ae578ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/mydakalistitem.vue"
export default component.exports